import { HttpService } from '../service/http-service';
import * as i0 from "@angular/core";
import * as i1 from "./auth.guard";
import * as i2 from "@angular/router";
import * as i3 from "../service/http-service";
export class RoleGuard {
    constructor(auth, router, httpService) {
        this.auth = auth;
        this.router = router;
        this.httpService = httpService;
    }
    canActivate(route) {
        if (sessionStorage.getItem('token') === null || sessionStorage.getItem('token') === '') {
            return false;
        }
        const data = route.data;
        return this.checkStatusByRoutingModule(data);
    }
    checkStatusByRoutingModule(data) {
        if (!HttpService.checkPrivilege(data.routingModule)) {
            this.httpService.showSnackBar('warning', 'You have not permission to access this URL !!!');
            return false;
        }
        return true;
    }
    checkStatusByRole(data) {
        for (let role of data.roles) {
            if (HttpService.getCurrentUserRole() === role) {
                return true;
            }
        }
        this.httpService.showSnackBar('warning', 'You have not permission to access this URL !!!');
        return false;
    }
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute);
    }
}
RoleGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleGuard_Factory() { return new RoleGuard(i0.ɵɵinject(i1.AuthGuard), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.HttpService)); }, token: RoleGuard, providedIn: "root" });
